import { z } from "zod";

export const getIncomingInvoiceParamsSchema = z.object({
	// An invoice id is a uuid and every read reaches a uuid column, so anything else is a bad
	// request rather than a lookup that fails inside the database.
	incomingInvoiceId: z.uuid(),
});

export type GetIncomingInvoiceParamsSchema = z.infer<typeof getIncomingInvoiceParamsSchema>;
